import useSWRImmutable from "swr/immutable";
import { useApiClient } from "@/hooks/useApiClient";
import { type ContactCategory, getContactCategories } from "../api/contactAPI";

interface UseContactCategoriesReturn {
  categories: ContactCategory[];
  isLoading: boolean;
  isError: boolean;
}

export const useContactCategories = (
  open: boolean
): UseContactCategoriesReturn => {
  const { apiClient } = useApiClient();

  const fetcher = async (): Promise<ContactCategory[]> => {
    return await getContactCategories(apiClient);
  };

  const { data, error, isLoading } = useSWRImmutable<ContactCategory[], Error>(
    open ? "/contact/categories/" : null,
    fetcher
  );

  return {
    categories: Array.isArray(data) ? data : [],
    isLoading,
    isError: Boolean(error),
  };
};
